import classNames from "classnames";
import { useState } from "react";
import { BaseButton } from "../../../../../../../components/Button/BaseButton.tsx";
import styles from "../../../../../../../components/Button/button.module.css";
import type { ButtonSize } from "../../../../../../../components/Button/Button.tsx";
import { Icon } from "../../../../../../../components/Icon/Icon.tsx";
import { Popover } from "../../../../../../../components/Popover/Popover.tsx";
import type { RgbaColor } from "../../../../../../../types.ts";
import { rgbaToHex, rgbaToString } from "../../../../../../../utils/colors.ts";
import { SETTINGS_ITEM_WIDTH } from "../../constants.ts";
import { DesignerColorPicker } from "./DesignerColorPicker.tsx";

export const DesignerColorPickerButton = ({
  color,
  onColorChange,
  size = "sm",
  ...rest
}: {
  color: RgbaColor;
  onColorChange: (color: RgbaColor) => void;
  size?: ButtonSize;
}) => {
  const [isColorPickerOpen, setIsColorPickerOpen] = useState(false);

  // FIXME: Users should have the possibility to select some colors from a predefined palette to improve user experience
  return (
    <Popover
      isOpen={isColorPickerOpen}
      onOpenChange={setIsColorPickerOpen}
      content={
        <DesignerColorPicker color={color} onColorChange={onColorChange} />
      }
      side="right"
      align="center"
      sideOffset={12}
    >
      <BaseButton
        className={classNames(
          "px-100 rounded-150",
          "bg-input-surface-rest hover:bg-input-surface-hover",
          styles[size],
          SETTINGS_ITEM_WIDTH,
        )}
        type="button"
        children={
          <div className="flex-row items-center justify-between">
            <div className="flex-row items-center gap-200">
              <div
                className="w-400 h-400 rounded-100 border"
                style={{ backgroundColor: rgbaToString(color) }}
              />
              <div className="label-md-default">
                {rgbaToHex(color).toUpperCase()}
              </div>
            </div>
            <Icon
              name={isColorPickerOpen ? "ChevronUp" : "ChevronDown"}
              size="sm"
            />
          </div>
        }
        {...rest}
      />
    </Popover>
  );
};
